<template>
    <div class="container-fluid">
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].status }}</label>
            <div class="col-sm-9 ">
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="active"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_active }}
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <label class="custom-cb">
                        <input type="checkbox"
                               v-model="selector_selected_status"
                               value="disable"
                               :disabled="loading"
                        ><span class="checkmark"></span> {{ trans[locale].status_disable }}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].user_type }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_user_type"
                             :options="selector_user_type_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="true"
                             :close-on-select="false"
                             :clear-on-select="false"
                             :hide-selected="true"
                             :searchable="false"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :disabled="loading"
                             :show-labels="false"
                >
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ trans[locale].staff }}</label>
            <div class="col-sm-9 ">
                <multiselect v-model="selector_selected_users"
                             :options="selector_user_options"
                             :placeholder="trans[locale].please_select"
                             :multiple="is_multiple"
                             :close-on-select="false"
                             :hide-selected="true"
                             :searchable="true"
                             :internal-search="true"
                             :allow-empty="true"
                             track-by="key"
                             label="name"
                             :limit="limit" :limitText="limitText"
                             :loading="loading"
                             :disabled="loading"
                             :show-labels="false"
                             :show-no-results="false"
                             group-values="libs"
                             group-label="language"
                             :group-select="true"
                >
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../../store/store';
    import UserSelector from './UserSelector';
    export default {
        mixins: [UserSelector],
        name: 'SelectorTeacher',
        props: {},
        store,
        data() {
            return Object.assign(
                {
                    selector_selected_status: [ 'active' ],
                    selector_selected_user_type: null,
                    selector_user_type_options: [],
                }
            )
        },
        watch: {
            selector_selected_status: _.debounce(
                function(newVal) {
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),
            selector_selected_user_type: _.debounce(
                function(newVal) {
                    this.getUserOptions();
                },
                store.getters.debounceMS,
            ),
        },
        methods: {
            initialSelector() {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [initialSelector]', 'gray');
                this.getUserTypeOptions();
            },
            getUserTypeOptions() {
                let self = this;
                let url = '/api/options/get-user-type/staff';
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getUserTypeOptions] => ' + url, 'gray');
                let method = 'get';
                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getUserTypeOptions]', 'success');
                    if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    self.selector_user_type_options = response.data;
                    this.getUserOptions();
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getUserTypeOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.getOptions(url, method, successCallBack, failedCallBack);
            },

            getUserOptions: _.debounce(function(){
                let self = this;
                let ignored_users = [];
                let url = "/api/options/get-teacher/_ALL_/";

                let selected_users_ids = [];
                _.forEach(self.selector_selected_users, (item) => {
                    selected_users_ids.push(item.key);
                });
                // url = url + _.join(selected_users_ids, this.array_delimiter);

                let ignored_users_ids = [];
                _.forEach(self.selector_ignored_users, (item) => {
                    ignored_users_ids.push(item.key);
                });

                let user_types = [];
                if (_.size(self.selector_selected_user_type) > 0) {
                    _.forEach(self.selector_selected_user_type, (item) => {
                        user_types.push(item.key);
                    });
                } else {
                    _.forEach(self.selector_user_type_options, (item) => {
                        user_types.push(item.key);
                    });
                }

                let req_param = {
                    extra: 'with_group',
                    locale: self.locale,
                    req_key: self.request_type,
                    selected_users: selected_users_ids,
                    ignored_users: ignored_users_ids,
                    user_type: user_types,
                    extra_param: {
                        account_status: self.selector_selected_status
                    },
                    filter_state: 'standby'
                };

                // url = url + '?' + $.param(req_param);
                let formData = req_param;
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] => METHODS [getUserOptions] => ' + url, 'gray');
                let method = 'post';

                let successCallBack = (response) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX Response [getUserOptions]', 'success');
                    if (_.isUndefined(response.data[0].libs)) {
                        if (this.is_debug) this.debugMessage(JSON.stringify(response.data), 'success');
                    } else {
                        if (this.is_debug) this.debugMessage(' Total Options: ' + _.size(response.data[0].libs), 'success');
                    }
                    self.selector_user_options = response.data;
                };
                let failedCallBack = (error) => {
                    if (this.is_debug) this.debugMessage('[' + this.component_name + '] => AJAX FAILED [getUserOptions]', 'error');
                    if (this.is_debug) this.debugMessage(error, 'error');
                    if (error.response.status == '422') {
                        this.$store.commit('setValidationError', error.toString())
                    } else {
                        this.$store.commit('setError', error.toString())
                    }
                };
                this.postOptions(url, method, formData, successCallBack, failedCallBack);
            }, store.getters.debounceMS),
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/SelectorTeacher.vue